import React from "react";
import {Form, Col, Row, Input} from "antd";
import DocumentUploader from "../../../../common/document-uploader/document-uploader";
import {Document} from "../../../../../domains/models/document/index";

interface ISecondaryEducationProps {
    fieldName: string;
    docType: string;
    employeeId: string;
    onUploadSuccess:(doc:Document)=>void;
}

const SecondaryEducation = (props: ISecondaryEducationProps) => {
    return (
        <section className={'pn__employee-create__form__fixed-width secondary-education'}>
            {/* Passing Year and Percentage */}
            <Row gutter={10}>
                <Col span={12}>
                    <Form.Item
                        name={[props.fieldName, "passingYear"]}
                        label={"Passing Year"}
                        className={"formInputFields"}
                        required={true}
                        rules={[
                            {
                                required: true,
                                message: "Please enter Passing Year",
                            },
                            {
                                pattern: /^(?:\d{4})(?:-\d{4})?$/,
                                message: "Please enter a valid year or year range (e.g., 2020 or 2020-2025)",
                            },
                            {
                                validator: (_, value) => {
                                    if (value) {
                                        const [startYear, endYear] = value.split('-').map(Number);
                                        if (startYear > new Date().getFullYear()) {
                                            return Promise.reject("Start year cannot be in the future.");
                                        }
                                        if (endYear && endYear < startYear) {
                                            return Promise.reject("End year must be greater than or equal to start year.");
                                        }
                                    }
                                    return Promise.resolve();
                                },
                            },
                        ]}>
                        <Input placeholder={'Enter passing year'}/>
                    </Form.Item>
                </Col>
                <Col span={12}>
                    <Form.Item
                        name={[props.fieldName, "percentage"]}
                        label={"Percentage"}
                        className={"formInputFields"}
                        required={true}
                        rules={[
                            {
                                validator: (_, value) => {
                                    if (value === undefined || value === '') {
                                        return Promise.reject("Please enter the percentage");
                                    }
                                    const num = parseFloat(value);
                                    if (isNaN(num)) {
                                        return Promise.reject("Please enter a valid percentage number");
                                    }
                                    const regex = /^\d+(\.\d{1,2})?$/;
                                    if (!regex.test(value)) {
                                        return Promise.reject("Please enter a valid value with up to two decimal places.");
                                    }
                                    if (num >= 0 && num <= 10) {
                                        return Promise.resolve();
                                    }
                                    if (num > 10 && num <= 100) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject("Enter percentage between 0–100");
                                }
                            }
                        ]}
                    >
                        <Input placeholder={'Enter percentage / CGPA'}/>
                    </Form.Item>
                </Col>
            </Row>

            {/* Board or University */}
            <Row gutter={10}>
                <Col span={12}>
                    <Form.Item
                        name={[props.fieldName, "boardOrUniversity"]}
                        label={"Board"}
                        className={"formInputFields"}
                        rules={[
                            {
                                required: true,
                                message: "Please enter Board",
                            },
                        ]}
                    >
                        <Input placeholder={'Enter board'}/>
                    </Form.Item>
                </Col>
            </Row>

            {/* Upload Document Component */}
            <Row gutter={10}>
                <Col span={12}>
                    <Form.Item
                        name={[props.fieldName, "documentId"]}
                        label={"Upload Document"}
                        style={{marginBottom: 'unset'}}
                        rules={[
                            {
                                required: true,
                                message: `Please upload the ${props.docType} Document`,
                            },
                        ]}
                    >
                        <DocumentUploader
                            disabled={false}
                            docType={props.docType}
                            purpose='EMPLOYMENT'
                            employeeId={props.employeeId}
                            onUploadSuccess={props.onUploadSuccess}
                        />
                    </Form.Item>
                </Col>
            </Row>
        </section>
    )
}

export default SecondaryEducation;
